import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { ColdSubject } from 'app/core/guards/cold-subject';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { FlowSandbox } from 'app/core/sandboxes/flow.sandbox';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { logger } from 'app/core/util/logger';
import { firstValueFrom, Observable } from 'rxjs';
import * as fromRoot from '..';

/**
 * Guard to async load a flow before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetFlowGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;
  private sandbox: FlowSandbox;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => FlowSandbox)) sandbox) {
    this.store = store;
    this.sandbox = sandbox;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    logger.debug(`In GetFlowGuard`);
    return new ColdSubject(async () => {
      const customer = await this.sandbox.getCustomerForEdit();
      return await firstValueFrom(this.sandbox.openFlow(customer?.id, route.paramMap.get('etmOrderNumber'), route.queryParamMap.get('salesOrderNumber')));
    });
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'FLOW.GET',
    };
  }
}
